import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Vaata teisi sarnaseid tooteid saalis

  <span style="color:#85c1dc;">**FI:**</span>
  Katso muita vastaavia tuotteita salissa

  <span style="color:#85c1dc;">**RU:**</span>
  Смотрите другие похожие товары в зале
*/
/* @__NO_SIDE_EFFECTS__ */
const m1409 = msg(
  mf`Vaata teisi sarnaseid tooteid saalis`,
  mf`Katso muita vastaavia tuotteita salissa`,
  mf`Смотрите другие похожие товары в зале`,
)

export { m1409 as 'w.module.submission_form.similar_products' }